<template>
    <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
        <h2>{{ i18n.get('common.login_social') }}</h2>
        
        <div v-for="(socialLogin, index) in socialLogins" :key="index">
            <a v-if="isEnabled(socialLogin)" 
               :href="generateLoginUrl(socialLogin)">
                {{ capitalize(socialLogin) }}
            </a>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    
    export default {
        name: "LoginSocialComponent",

        computed: {
            ...mapState([
                'socialLogins'
            ]),
        },

        methods: {
            generateLoginUrl(social) {
                return `${this.clientURL}/signin/${social}`;
            },

            isEnabled(social) {
                return this.socialLogins.indexOf(social) > -1;
            },
            
            capitalize(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
        }
    }
</script>
